<template>
  <div style="background-color: white; padding: 20px;">
    <div style="margin-bottom: 20px;display: flex">
      <div class="margin10">
        <select-area @areaListId="getAreaListId"/>
      </div>
      <el-input v-model="tableQuery.coachName" style="width: 200px;" @change="selectPage" placeholder="请输入姓名"></el-input>
      <el-date-picker value-format="YYYY-MM"
          style="width: 160px;margin-left: 10px"
          v-model="tableQuery.date"
          type="month"
          placeholder="请选择月份"
      />
      <el-button style="margin-left: 10px" type="primary" @click="selectPage">查询</el-button>
      <el-popconfirm @confirm="exportCourseEvaluation" title="确定要导出吗？">
        <template #reference>
          <el-button v-permission="['coursesEvaluate:export']" style="margin-left: 10px" type="primary">导出</el-button>
        </template>
      </el-popconfirm>
    </div>
    <el-table border :data="tableData" :cell-style="{ padding: '16px' }" height="600px" v-loading="tableQuery.loading" empty-text="未查询到数据">
      <el-table-column
          prop="campusName"
          label="教练所属校区"
          width="180">
      </el-table-column>
      <el-table-column label="教练" width="190">
        <template #default="scope">
          <div>{{scope.row.coachId}} - {{scope.row.coachName}}</div>
        </template>
      </el-table-column>
      <el-table-column label="总数量">
        <template #default="scope">
          <el-popover class="box-item" placement="right" :width="800">
            <div>
              <el-table :data="scope.row.list">
                <el-table-column width="100" property="courseRecordId" label="课时Id" />
                <el-table-column property="studentName" label="学员姓名" />
                <el-table-column property="campusName" label="上课校区" />
                <el-table-column property="rating" label="评分" />
                <el-table-column label="是否评价">
                  <template #default="scope">
                    <div>{{scope.row.isEvaluation == 0 ? '未评':'已评'}}</div>
                  </template>
                </el-table-column>
                <el-table-column property="notes" label="评价" />
              </el-table>
            </div>
            <template #reference>
              <div>共计需要{{scope.row.courseCount}}位家长进行评价</div>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="已评数量">
        <template #default="scope">
          <div>已有{{scope.row.courseEvaluationCount}}位家长评价</div>
        </template>
      </el-table-column>
      <el-table-column label="已评得分">
        <template #default="scope">
          <div>{{scope.row.score}}分</div>
        </template>
      </el-table-column>
      <el-table-column label="平均得分">
        <template #default="scope">
          <div>{{scope.row.scorePercentage}}分</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          style="text-align: right;margin: 20px 10px;"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="tableQuery.pageSize"
          @current-change="selectPage"
          layout="total, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import {selectSummaryByPage,exportCourseEvaluation} from "@/api/coursesRecord";
import selectArea from "../../components/SelectArea";
export default {
  components:{selectArea},
  name: "CoursesEvaluate",
  data() {
    return {
      total:0,
      tableData:[],
      tableQuery:{
        areaList: [],
        coachName: "",
        month: null,
        date:null,
        pageIndex: 1,
        pageSize: 10,
        year: null,
        loading:false
      }
    }
  },
  methods:{
    exportCourseEvaluation(){
      if (this.tableQuery.date == null){
        this.tableQuery.year = null;
        this.tableQuery.month = null;
      }else {
        const [year, month] = this.tableQuery.date.split('-');
        this.tableQuery.year = year;
        this.tableQuery.month = month;
      }
      this.$message.success("正在导出 请稍等...");
      exportCourseEvaluation(this.tableQuery).then(val=>{
        console.log(val)
          this.$message.success("导出成功！，请在右上角下载查看！");
      })
    },
    getAreaListId(val) {
      this.tableQuery.areaList = val;
    },
    selectPage(val){
      if (val){
        this.tableQuery.pageIndex = val;
      }

      if (this.tableQuery.date == null){
        this.tableQuery.year = null;
        this.tableQuery.month = null;
      }else {
        const [year, month] = this.tableQuery.date.split('-');
        this.tableQuery.year = year;
        this.tableQuery.month = month;
      }

      selectSummaryByPage(this.tableQuery).then(val=>{
        if (val.code == 200) {
          this.tableData = val.data.records;
          this.total = val.data.total;
        } else {
          this.$message.error("获取表格数据失败");
        }
      })
    }
  },
  created() {
    this.selectPage();
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
</style>